import React from 'react'
import { cn } from 'utils/cn'

export interface SeparatorProps {
    orientation?: 'horizontal' | 'vertical'
    variant?: 'primary' | 'secondary' | 'tertiary'
    showText?: boolean
    text?: string
    style?: React.CSSProperties
}

const lineColorMap: Record<string, string> = {
    primary: 'bg-border',
    secondary: 'bg-foreground-muted',
    tertiary: 'bg-foreground',
}

export const Separator = ({ orientation = 'horizontal', variant = 'primary', showText = false, text = 'OR', style }: SeparatorProps) => {
    const isHorizontal = orientation === 'horizontal'
    const lineClass = cn('flex-[1_0_0]', isHorizontal ? 'h-px min-w-px' : 'w-px min-h-px', lineColorMap[variant])

    return (
        <div
            role="separator"
            aria-orientation={orientation}
            className={cn('flex items-center justify-center rounded-sm', isHorizontal ? 'w-full flex-row' : 'h-full flex-col')}
            style={style}
        >
            <div className={lineClass} />
            {showText && (
                <span className={cn('shrink-0 whitespace-nowrap text-xs font-medium text-foreground-muted', isHorizontal ? 'px-3' : 'px-1 py-2')}>{text}</span>
            )}
            {showText && <div className={lineClass} />}
        </div>
    )
}
